(() => {
  const initialize = (root) => {
    if (root.dataset.bbReady) return;
    root.dataset.bbReady = 'true';
    root.classList.add('is-ready');
    const $ = selector => root.querySelector(selector);
    const all = selector => [...root.querySelectorAll(selector)];
    const form = $('[data-bb-form]');
    const select = $('[data-bb-select]');
    const add = $('[data-bb-add]');
    const stickyAdd = $('[data-bb-sticky-add]');
    const endAdd = $('[data-bb-end-add]');
    const buyNow = $('[data-bb-buy-now]');
    const status = $('[data-bb-status]');
    const sticky = $('[data-bb-sticky]');
    const quantity = $('[data-bb-quantity]');
    const lightbox = $('[data-bb-lightbox]');
    const zoom = $('[data-bb-zoom]');
    const galleryButtons = all('[data-bb-gallery-button]');
    const shadeInputs = all('[data-bb-variant]');
    const shadeAvailability = new Map(shadeInputs.map(input => [input, !input.disabled]));
    const routeRoot = window.Shopify?.routes?.root || '/';
    const cartUrl = window.routes?.cart_url || `${routeRoot.replace(/\/$/, '')}/cart`;
    let busy = false;

    const selectedShade = () => shadeInputs.find(input => input.checked);
    const setBusy = value => {
      busy = value;
      shadeInputs.forEach(input => { input.disabled = value || !shadeAvailability.get(input); });
      const available = Boolean(selectedShade() && shadeAvailability.get(selectedShade()));
      add.disabled = value || !available;
      stickyAdd.disabled = value || !available;
      endAdd.disabled = value || !available;
      buyNow.hidden = !available;
      buyNow.setAttribute('aria-disabled', String(!available));
      add.setAttribute('aria-busy', String(value));
      stickyAdd.setAttribute('aria-busy', String(value));
      $('[data-bb-add-label]').textContent = value ? 'Aggiunta in corso…' : available ? 'Aggiungi al carrello' : 'Esaurito';
    };
    const setVariant = (radio, changeUrl = true) => {
      if (!radio) return;
      select.value = radio.value;
      all('[data-bb-shade-card]').forEach(card => card.setAttribute('aria-pressed', String(card.dataset.bbShadeCard === radio.dataset.code)));
      const code = radio.dataset.code;
      $('[data-bb-shade-name]').textContent = `· ${code}`;
      $('[data-bb-sticky-shade]').textContent = code;
      $('[data-bb-price]').textContent = radio.dataset.price;
      $('[data-bb-sticky-price]').textContent = radio.dataset.price;
      const compare = $('[data-bb-compare]');
      compare.textContent = radio.dataset.compare || '';
      compare.hidden = !radio.dataset.compare;
      quantity.min = radio.dataset.min || '1';
      if (radio.dataset.max) quantity.max = radio.dataset.max;
      else quantity.removeAttribute('max');
      quantity.step = radio.dataset.step || '1';
      if (Number(quantity.value) < Number(quantity.min) || (quantity.max && Number(quantity.value) > Number(quantity.max))) quantity.value = quantity.min;
      setBusy(false);
      updateBuyNow();
      status.textContent = '';
      if (changeUrl) {
        try {
          const url = new URL(location.href);
          url.searchParams.set('variant', radio.value);
          history.replaceState(history.state, '', `${url.pathname}${url.search}${url.hash}`);
        } catch (_) { /* Preview file URLs may restrict history. */ }
      }
    };
    shadeInputs.forEach(input => input.addEventListener('change', () => setVariant(input)));
    const updateBuyNow = () => {
      const qty = Math.max(Number(quantity.min) || 1, Number(quantity.value) || 1);
      buyNow.href = `${cartUrl}/${select.value}:${qty}`;
    };
    quantity.addEventListener('change', updateBuyNow);
    all('[data-bb-shade-card]').forEach(card => card.addEventListener('click', () => {
      const radio = shadeInputs.find(input => input.dataset.code === card.dataset.bbShadeCard);
      if (!radio || radio.disabled) return;
      radio.checked = true;
      radio.dispatchEvent(new Event('change', { bubbles: true }));
      $('[data-bb-form]').scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth', block: 'center' });
    }));
    const requested = new URLSearchParams(location.search).get('variant');
    const initial = shadeInputs.find(input => input.value === requested && !input.disabled) || shadeInputs.find(input => input.checked && !input.disabled) || shadeInputs.find(input => !input.disabled);
    if (initial) { initial.checked = true; setVariant(initial, false); }

    const showImage = index => {
      all('[data-bb-image]').forEach(image => {
        image.hidden = image.dataset.bbImage !== String(index);
        image.classList.toggle('is-active', !image.hidden);
      });
      galleryButtons.forEach(button => button.setAttribute('aria-current', String(button.dataset.bbGalleryButton === String(index))));
    };
    galleryButtons.forEach(button => button.addEventListener('click', () => showImage(button.dataset.bbGalleryButton)));
    $('[data-bb-gallery] .bp-bb__stage').addEventListener('keydown', event => {
      if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
      event.preventDefault();
      const index = galleryButtons.findIndex(button => button.getAttribute('aria-current') === 'true');
      showImage((index + (event.key === 'ArrowRight' ? 1 : -1) + galleryButtons.length) % galleryButtons.length);
    });
    $('[data-bb-show-swatches]').addEventListener('click', () => {
      showImage(1);
      $('[data-bb-gallery]').scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth', block: 'center' });
    });
    zoom.addEventListener('click', () => {
      const active = $('[data-bb-image].is-active');
      const source = active?.querySelector('img');
      if (!source) return;
      const image = $('[data-bb-lightbox-image]');
      image.src = source.currentSrc || source.src;
      image.alt = source.alt;
      lightbox.classList.toggle('is-original-swatch', active.dataset.bbImage === '3');
      $('[data-bb-lightbox-caption]').textContent = active.querySelector('figcaption')?.textContent || '';
      lightbox.showModal();
    });
    $('[data-bb-lightbox-close]').addEventListener('click', () => lightbox.close());
    lightbox.addEventListener('click', event => { if (event.target === lightbox) lightbox.close(); });
    stickyAdd.addEventListener('click', () => { if (!busy) form.requestSubmit(add); });
    endAdd.addEventListener('click', () => { if (!busy) form.requestSubmit(add); });
    $('[data-bb-share]').addEventListener('click', async () => {
      const details = { title: 'BB Cream · Beauty Price Cosmetics', url: location.href };
      try {
        if (navigator.share) await navigator.share(details);
        else if (navigator.clipboard?.writeText) { await navigator.clipboard.writeText(details.url); status.textContent = 'Link copiato.'; }
      } catch (_) { /* The visitor can dismiss the native share sheet. */ }
    });

    const story = $('#story');
    const chapters = all('#story [data-c]');
    const visuals = all('#story .st-vis .v');
    const progress = all('#story .st-prog i');
    let storyFrame = 0;
    const updateStory = () => {
      storyFrame = 0;
      const box = story.getBoundingClientRect();
      const travel = Math.max(1, box.height - innerHeight);
      const ratio = Math.min(1, Math.max(0, -box.top / travel));
      const active = Math.min(2, Math.floor(ratio * 3));
      chapters.forEach((chapter, index) => chapter.classList.toggle('on', index === active));
      visuals.forEach((visual, index) => visual.classList.toggle('on', index === active));
      progress.forEach((bar, index) => bar.style.setProperty('--f', String(Math.min(1, Math.max(0, ratio * 3 - index)))));
    };
    const scheduleStory = () => { if (!storyFrame) storyFrame = requestAnimationFrame(updateStory); };
    addEventListener('scroll', scheduleStory, { passive: true });
    addEventListener('resize', scheduleStory);
    updateStory();

    const observer = new IntersectionObserver(([entry]) => {
      // The bar belongs after the purchase form; a CTA below the fold is not yet passed.
      const visible = !entry.isIntersecting && entry.boundingClientRect.bottom < 0;
      sticky.classList.toggle('is-visible', visible);
      sticky.inert = !visible;
      sticky.setAttribute('aria-hidden', String(!visible));
    }, { threshold: 0 });
    sticky.inert = true;
    sticky.setAttribute('aria-hidden', 'true');
    observer.observe(add);
    root._bbCleanup = () => { observer.disconnect(); removeEventListener('scroll', scheduleStory); removeEventListener('resize', scheduleStory); if (storyFrame) cancelAnimationFrame(storyFrame); if (lightbox.open) lightbox.close(); };

    form.addEventListener('submit', async event => {
      if (!window.fetch) return;
      event.preventDefault();
      if (busy || !selectedShade() || selectedShade().disabled || !form.reportValidity()) return;
      const variantId = Number(select.value);
      const qty = Number(quantity.value);
      if (!Number.isSafeInteger(variantId) || !Number.isInteger(qty) || qty < Number(quantity.min) || (quantity.max && qty > Number(quantity.max))) return;
      setBusy(true);
      status.textContent = 'Aggiunta al carrello…';
      const drawer = document.querySelector('cart-drawer');
      const sections = drawer?.getSectionsToRender?.().map(section => section.id) || [];
      let added = false;
      let response;
      try {
        const result = await fetch(`${routeRoot.replace(/\/$/, '')}/cart/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          credentials: 'same-origin',
          body: JSON.stringify({ id: variantId, quantity: qty, sections, sections_url: location.pathname })
        });
        response = await result.json();
        if (!result.ok || response.status) throw new Error(response.description || response.message || 'Impossibile aggiungere al carrello.');
        added = true;
      } catch (error) {
        status.textContent = error.message || 'Impossibile aggiungere al carrello. Riprova.';
      }
      if (added) {
        status.textContent = 'Aggiunto al carrello.';
        if (drawer && typeof drawer.renderContents === 'function') {
          try {
            drawer.setActiveElement?.(add);
            if (!response.sections?.['cart-drawer'] || !response.sections?.['cart-icon-bubble']) {
              const fresh = await fetch(`${routeRoot}?sections=cart-drawer,cart-icon-bubble`, { credentials: 'same-origin' });
              if (!fresh.ok) throw new Error('cart-sections');
              response.sections = await fresh.json();
            }
            drawer.renderContents(response, !document.body.classList.contains('page-overlay-cart-on'));
          } catch (_) {
            document.dispatchEvent(new CustomEvent('cart-drawer:refresh'));
            status.textContent = 'Aggiunto al carrello. Apri il carrello per vedere il prodotto.';
          }
        } else {
          location.assign(cartUrl);
        }
        fetch(`${routeRoot.replace(/\/$/, '')}/cart.js`, { credentials: 'same-origin' })
          .then(result => result.ok ? result.json() : null)
          .then(cart => { if (cart) document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { cart } })); })
          .catch(() => {});
      }
      setBusy(false);
    });
  };
  const scan = (context = document) => {
    if (context.matches?.('[data-bb-pdp]')) initialize(context);
    context.querySelectorAll?.('[data-bb-pdp]').forEach(initialize);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => scan(), { once: true });
  else scan();
  document.addEventListener('shopify:section:load', event => scan(event.target));
  document.addEventListener('shopify:section:unload', event => {
    const roots = event.target.matches?.('[data-bb-pdp]') ? [event.target] : [...event.target.querySelectorAll?.('[data-bb-pdp]') || []];
    roots.forEach(root => { root._bbCleanup?.(); delete root.dataset.bbReady; });
  });
})();
